module.exports = __webpack_public_path__ + "static/img/contract-hash.0a5a16de.png";